module.exports = __webpack_public_path__ + "static/media/offile imae.961eef50.png";